<template>
  <section class="section">
    <b-loading :is-full-page="isFullPage" :active="!trainer" :can-cancel="true"></b-loading>
    <div class="container" v-if="trainer">
      <div class="columns">
        <div class="column is-one-fifth">
          <figure class="media-left">
            <p class="image is-96x96">
              <img class="is-rounded" :src="trainer.photo || noPhotoSrc">
            </p>
          </figure>
        </div>
        <div class="column">
          <h2 class="title is-3">
            {{ trainer.name }}
          </h2>
          <h6 class="subtitle is-6">
            Joined {{ trainer.createdAt | moment("  MMMM DD, YYYY [at] h:mm:ss a")}}
          </h6>
          <div v-if="trainer.instagram">
            <span class="icon has-text-danger is-small"><i class="fab fa-instagram"></i></span>
            {{ trainer.instagram }}
          </div>
        </div>
      </div>
      <div class="details-columns">
        <div class="columns">
          <div class="column is-one-fifth">Name</div>
          <div class="column">{{ trainer.name }}</div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">Phone</div>
          <div class="column">{{trainer.phone}}</div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">Email</div>
          <div class="column">{{trainer.email}}</div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">Zip Code</div>
          <div class="column">{{trainer.zipCode}}</div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">Certifications</div>
          <div class="column">{{ trainer.certifications }}</div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">Specialities</div>
          <div class="column">{{ trainer.specialties }}</div>
        </div>
        <div class="columns">
          <div class="column is-one-fifth">Bio</div>
          <div class="column">{{ trainer.bio }}</div>
        </div>
      </div>

      <div class="columns" v-if="trainer.video">
        <div class=" is-offset-one-fifth column">
          <video width="500" controls>
            <source :src="trainer.video">
            Your browser does not support HTML5 video.
          </video>
        </div>
      </div>

      <hr>
      <h5 class="title is-5">Notes:</h5>
      <div class="columns" v-for="(trainerNote,index) in trainer.trainerNotes" :key="trainerNote.id+'-'+index">
        <div class="column is-one-fifth"><p>{{trainerNote.createdAt | moment("  MMMM DD, YYYY ")}}</p></div>
        <div class="column">
          <p> {{trainerNote.note}}</p>
        </div>
      </div>
      <div class="columns">
        <div class=" is-offset-one-fifth column">
          <form @submit.prevent="createNotes">
            <b-field label="">
              <b-input is-medium maxlength="100" type="textarea" v-model="notes"></b-input>
             </b-field>
            <button type="submit" class="button is-primary">Submit</button>
          </form>
        </div>
      </div>
      <hr>
      <div class="columns">
        <div class="buttons">
          <router-link class="button is-primary is-outlined" :to="{ name: 'trainerUpdate', params: { id: trainer.id }}">Edit Trainer</router-link>
          <!--Features for managing active trainers-->
          <template v-if="!trainer.deactivatedAt">
            <button class="button is-primary is-outlined" @click="openResetPasswordModal(trainer)" v-if="trainer.user">Send Password Reset</button>
            <button class="button is-primary is-outlined" @click="sendTrainerInvite(trainer)" v-if="!trainer.user">Send Sign-Up Invite</button>
            <button class="button is-danger is-outlined" @click="openDeactivateModal(trainer)">Deactivate Trainer</button>
          </template>
        </div>
      </div>
    </div>
    <deactivate-trainer-modal :trainer="trainer" ref="manageDeactivateModal" @handleClose="closeManageModal()"></deactivate-trainer-modal>
    <reset-password-modal  :trainer="trainer" ref="resetPasswordModal" @handleClose="closeManageModal()"></reset-password-modal>
  </section>
</template>

<script>
import { trainerQuery, createTrainerNoteMutation } from '../../graphql/trainers'
import { sendUserInvite } from '../../graphql/users'
import DeactivateTrainerModal from './DeactivateTrainerModal.vue'
import ResetPasswordModal from './ResetPasswordModal.vue'
export default {
  name: 'TrainerDetails',
  components: {
    DeactivateTrainerModal,
    ResetPasswordModal
  },
  data () {
    return {
      isLoading: false,
      isFullPage: true,
      id: this.$route.params.id,
      trainer: null,
      notes: '',
      noPhotoSrc: 'https://dummyimage.com/400x400/000/fff.jpg&text=No+Photo'
    }
  },
  apollo: {
    trainer: {
      query: trainerQuery,
      variables () {
        return {
          id: this.id
        }
      },
      fetchPolicy: 'network-only'
    }
  },
  methods: {
    // open the modal to manage a user
    openDeactivateModal (data) {
      this.trainer = data
      this.$refs.manageDeactivateModal.$refs.modal.open()
    },
    openResetPasswordModal (data) {
      this.trainer = data
      this.$refs.resetPasswordModal.$refs.modal.open()
    },
    closeManageModal (id) {
      this.$refs.manageDeactivateModal.$refs.modal.close()
      this.$refs.resetPasswordModal.$refs.modal.close()
    },
    createNotes () {
      this.$apollo.mutate({
        mutation: createTrainerNoteMutation,
        variables: {
          trainerId: this.id,
          note: this.notes
        }
      })
        .then(() => {
          this.notes = ''
          this.refetchTrainerQuery()
        })
        .catch((e) => {
          this.$toast.open({
            message: 'Error:' + (e.message || e),
            type: 'is-danger',
            duration: 5000
          })
          this.notes = ''
        })
    },
    // refetch the applications list after the contents may have changed
    refetchTrainerQuery () {
      this.$apollo.queries.trainer.refetch()
    },
    // send a registration invite to the trainer
    sendTrainerInvite () {
      this.$apollo.mutate({
        mutation: sendUserInvite,
        variables: {
          trainerId: this.trainer.id
        }
      })
        .then(() => {
          this.$toast.open({
            message: 'Invitation Sent!',
            type: 'is-success'
          })
          // refetch the query
          this.refetchTrainerQuery()
        })
        .catch((e) => {
          this.$toast.open({
            message: (e.message || e),
            type: 'is-danger',
            duration: 5000
          })
        })
    }
  }
}
</script>
